(function ($) {

    // TODO: Need to Refact !!!!!!!
    // TODO: use new Map or new Set

    $(document).ready(() => {
        const element = document.getElementById('size-fabric-selectors');

        const selected = {
           size: null,
           fabric: null,
           color: null
        };

        if (!element) {
            return
        }

        const SECTION_ID = element.getAttribute('data-section-id');

        const utils = {
            replaceSpace: function (key) {
                return key.replace(' ', '-');
            },
            getInnerHtml: function (id, defaultValue) {
                const element = document.getElementById(id);

                return element ? element.innerHTML : JSON.stringify(defaultValue);
            },
        };

        const information = {
            parseJSON: function(info) {
                try {
                    return JSON.parse(info);
                } catch(e) {}
            },
            getCurrentVariant: function (id = SECTION_ID) {
                return this.parseJSON(utils.getInnerHtml(`CurrentVariantJson-${id}`, {}));
            },
            getVariants: function (id = SECTION_ID) {
                return this.parseJSON(utils.getInnerHtml(`VariantsJson-${id}`, []));
            },
            getProduct: function () {
                return this.parseJSON(utils.getInnerHtml(`json-product`, {}));
            },
            getFabrics: function () {
                return this.parseJSON(utils.getInnerHtml('json-fabric', []));
            },
            getColors: function () {
                return this.parseJSON(utils.getInnerHtml('json-color', []));
            },
            getImagesOfProduct: function () {
                return this.parseJSON(utils.getInnerHtml('json-images', []));
            },
            getTags: function () {
                return this.parseJSON(utils.getInnerHtml('json-tags', []));
            }
        };

        const $selectors = {
            productSection: $(`#ProductSection-${SECTION_ID}`),
            productSelect: $(`#ProductSelect-${SECTION_ID}`),
            addToCart: $(`#AddToCart-${SECTION_ID}`),
            addToCartText: $(`#AddToCartText-${SECTION_ID}`),
            menuFabric: $('.menu.fabric'),
            trigger: $('.menu-trigger'),
            sizeTrigger: $('.size-trigger'),
            fabricTrigger: $('.fabric-trigger'),
            content: $('.menu-content'),
            contentSize: $('.content-size'),
            contentFabric: $('.fabric-content'),
            navTabs:  $('.nav-tabs'),
            navItems: $('.nav-item'),
            tabContent: $('.tab-content'),
            sizeSelector: $('#size-selector'),
            fabricSelector: $('#fabric-selector'),
            colorSelector: $('#color-selector'),
            fabricContents: $('.content-fabric'),
            productPolicies: $('#ProductPolicies')
        };

        const propData = {
            sizeThemeSelectorId: $selectors.sizeSelector.data('section'),
            fabricThemeSelectorId: $selectors.fabricSelector.data('section'),
            colorThemeSelectorId: $selectors.colorSelector.data('section'),
            sizeThemeSelectorIndex: $selectors.sizeSelector.data('index'),
            fabricThemeSelectorIndex: $selectors.fabricSelector.data('index'),
            colorThemeSelectorIndex: $selectors.colorSelector.data('index'),
        };

        const updateVariant = {
            currentVariant: information.getCurrentVariant() || {},

            $container: $selectors.productSection,

            enableHistoryState: $selectors.productSection.data('enable-history-state') || false,

            trigger: function (variant) {
                this._updateMasterSelect(variant);
                this._updatePrice(variant);
                this._updateUnitPrice(variant);
                this._updateSKU(variant);
                this._updateImages(variant);
                this.currentVariant = variant;

                if (this.enableHistoryState) {
                    this._updateHistoryState(variant);
                }
            },

            _setImageByColor: function (variant)  {
                const color = variant[propData.colorThemeSelectorIndex];
                const found = information.getImagesOfProduct().find(img => img.alt === color);

                if (found && variant.featured_image) {
                    variant.featured_media.id = found.id;
                }

                return variant;
            },

            _updateImages: function(variant) {
                variant = this._setImageByColor(variant);

                this.$container.trigger({
                    type: 'variantImageChange',
                    variant: variant
                });
            },

            _updatePrice: function(variant) {
              
               if (document.getElementById("ARProduct")) {
              var variantIdString = (variant.id).toString();
              currentGLB = "https://poshliving.charpstar.net/Android/" + variantIdString + ".glb";
              currentUSDZ = "https://poshliving.charpstar.net/iOS/" + variantIdString + ".usdz";
              checkLink(currentGLB);
              }


                if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
                    return;
                }

                this.$container.trigger({
                    type: 'variantPriceChange',
                    variant: variant
                });
            },

            _updateUnitPrice: function(variant) {
                if (variant.unit_price === this.currentVariant.unit_price) {
                    return;
                }

                this.$container.trigger({
                    type: 'variantUnitPriceChange',
                    variant: variant
                });
            },

            _updateSKU: function(variant) {
                if (variant.sku === this.currentVariant.sku) {
                    return;
                }

                this.$container.trigger({
                    type: 'variantSKUChange',
                    variant: variant
                });
            },

            _updateHistoryState: function(variant) {
                if (!history.replaceState || !variant) {
                    return;
                }

                var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
                window.history.replaceState({path: newurl}, '', newurl);
            },

            _updateMasterSelect: function(variant) {
                $selectors.productSelect.val(variant.id);
            },
        };

        const isDevice = {
            devices: [/iPhone|iPad|iPod/i, /Android/i, /BlackBerry/i, /Opera Mini/i, /IEMobile/i],
            detect: function () {
                return this.devices.some((device) => navigator.userAgent.match(device));
            },
            Android: function() {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function() {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function() {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function() {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function() {
                return navigator.userAgent.match(/IEMobile/i);
            },
            all: function() {
                return (this.Android() || this.BlackBerry() || this.iOS() || this.Opera() || this.Windows());
            }
        };

        const _variants = information.getVariants();

        const _fabrics = information.getFabrics();

        function onClickMenuTrigger() {
            $selectors.trigger.on('click', function (e) {
                const $that = $(this);
                e.preventDefault();

                if ($that.hasClass('unavailable')) {
                    return;
                }

                if ($that.next('.menu-content').is(':visible')) {
                    $that.removeClass('open');
                    $that.next('.menu-content').slideUp();
                } else {
                    $selectors.trigger.removeClass('open');
                    $that.addClass('open');
                    $selectors.trigger.next('.menu-content').slideUp();
                    $that.next('.menu-content').slideToggle();
                }

                $selectors.fabricTrigger.hasClass('open') ? initTabs() : destroyTabs();
            });
        }

        function initTabs() {
            const leftArrow = `
                <div class="scrtabs-tab-scroll-arrow scrtabs-tab-scroll-arrow-left">
                  <button class="scrtabs-arrow-btn scrtabs-click-target" type="button">
                    <span class="arrow arrow-prev"></span>
                  </button>
                </div>
            `;

            const rightArrow = `
                <div class="scrtabs-tab-scroll-arrow scrtabs-tab-scroll-arrow-right">
                  <button class="scrtabs-arrow-btn scrtabs-click-target" type="button">
                    <span class="arrow arrow-next"></span>
                  </button>
                </div>
            `;

            const config = {
                scrollToTabEdge: true,
                enableSwiping: true,
                disableScrollArrowsOnFullyScrolled: true,
                leftArrowContent: leftArrow,
                rightArrowContent: rightArrow
            };

            $selectors.navTabs.scrollingTabs(config).on('ready.scrtabs', () => {
                $('.nav-link').click(() => {
                    setTimeout(() => {
                        $('.nav-tabs').scrollingTabs('scrollToActiveTab');
                    }, 10);
                });
            });
        }

        function destroyTabs() {
            $selectors.navTabs.scrollingTabs('destroy');
        }

        function initFabricSelector() {
           const getTabContentItem = (fabric, color, size, img) => {
                return $(`
                   <div class="item item-fabric" data-color="${color}" data-fabric="${fabric}" data-size="${size}">
                      <div class="item-control">
                         <img alt="Fabric" class="image-fabric" data-img="${img}" src="${img}" xoriginal="${img}"/> 
                         <a href="${img}" target="_blank">
                          <svg class="icon" id="i-external" viewBox="0 0 32 32" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                            <path d="M14 9 L3 9 3 29 23 29 23 18 M18 4 L28 4 28 14 M28 4 L14 18"/>
                          </svg>
                         </a>
                      </div>
                      <div class="wrap-text">
                         <div class="item-description item-text">${color}</div>
                      </div>
                   </div>
                `);
            };

           const initTabContent = function () {
                const groupedVariantByFabric = getGroupedVariantByFabric();

                Object.keys(groupedVariantByFabric).forEach((key, index) => {
                    const descriptionOfFabric = theme.DescriptionOfFabric[key];
                    const fabricName = utils.replaceSpace(key);
                    const wrapContent = $(`<div class="wrap-content ${fabricName}"></div>`);
                    const description = $('<div class="description-fabric"></div>');
                    const title = $(`<p class="title">${key}</p>`);
                    const descriptionInfo = $(`<div class="info">${descriptionOfFabric}</div>`);
                    const content = $(`<div class="content content-fabric"></div>`);

                    groupedVariantByFabric[key].forEach((variant) => {
                        const img = variant['featured_image'] ? variant['featured_image'].src : '';
                        const element = getTabContentItem(key, variant[propData.colorThemeSelectorIndex], variant[propData.sizeThemeSelectorIndex], img);

                        if (img) {
                            $(content).append(element);
                            if (!isDevice.detect()) {
                                element.find('.image-fabric').xzoom({
                                    position: 'left',
                                    mposition: 'inside',
                                    // tint: '#333',
                                    Xoffset: 15,
                                    Yoffset: -5,
                                    zoomWidth: 250,
                                    zoomHeight: 250,
                                    smoothZoomMove: 5
                                });
                            }
                        }
                    });

                    if (index !== 0) {
                        wrapContent.addClass('hide');
                    }

                    // if (descriptionOfFabric) {
                    //     wrapContent.append(title);
                    // }


                    wrapContent.append(content);

                    if (descriptionOfFabric) {
                        // description.append(descriptionTitle);

                        description.append(descriptionInfo);

                        wrapContent.append(description);
                    }

                    $selectors.tabContent.append(wrapContent);
                });

                onClickTab();
                onClickFabric();
            };

           const onClickTab = function() {
                $selectors.navItems.first().addClass('active-tab');

                $selectors.navItems.on('click', function (event) {
                    const $that = $(this);

                    if ($that.hasClass('disabled')) {
                        event.stopPropagation();
                        return;
                    }

                    const fabric = $that.data('fabric');
                    const fabricName = utils.replaceSpace(fabric);
                    const element = $(`.${fabricName}`);

                    // remove/add class active-tab to child
                    $that.addClass('active-tab');

                    $that.siblings().removeClass('active-tab');

                    // show hide content of the tab
                    element.removeClass('hide');

                    element.siblings().addClass('hide');
                });
            };

           const onClickFabric = function () {
               $('.item-fabric').on('click', function () {
                  const $that = $(this);
                  const fabric = $that.data('fabric');
                  const color = $that.data('color');

                  selected.fabric = fabric;
                  selected.color = color;

                  if ($that.hasClass('disabled-fabric')) {
                      return;
                  }

                  $that.addClass('active-fabric');

                  $selectors.contentFabric.find('.item-fabric').not($that).removeClass('active-fabric');

                  // set selected value to a header of selector
                  $selectors.fabricTrigger.find('.value').text(`${fabric} / ${color}`);

                  const selectedVariant = getSelectedVariant();

                  if (!!selectedVariant) {
                      updateProductPolicies(!!selectedVariant);
                      updateRangePriceByFabric();
                      updateCartButton(selectedVariant);
                      updateVariant.trigger(selectedVariant);
                  }
               });
            };

           initTabContent();
        }

        function initSizeSelector() {
            const $options = $selectors.contentSize.find('.item');

            const onClickSizeOption = function () {
                $options.on('click', function () {
                    const size = $(this).data('value');

                    $selectors.contentFabric.find('.item-fabric').each(function(index, item) {
                        const $item = $(item);

                        if ($item.data('size') === size) {
                            $item.removeClass('disabled-fabric');
                        } else {
                            $item.addClass('disabled-fabric');
                        }
                    });

                    selected.size = size;
                    // reset fabric value
                    selected.fabric = null;
                    // reset fabric value on view
                    $selectors.fabricTrigger.find('.value').text(theme.strings.customSelectNoValue);

                    updateAvailableFabricSelector(!!size);

                    updateCartButton(false)

                    updateRangePriceBySize(size);

                    // updateAvailableTabs(size);

                    // set selected value to a header of selector
                    $selectors.sizeTrigger.find('.value').text(size);
                });

            };

            const setDescriptionSize = function () {
                $options.each(function (index, item){
                    const $description = $(item).find('.item-description');
                    const option = $description.data('value');
                    // get description of the size option
                    const description = theme.DescriptionOfSize[option];

                    if (description) {
                        $description.css({ 'marginTop': '10px', 'display': 'block'});
                        $description.html(description);
                    }
                })
            };

            onClickSizeOption();
            setDescriptionSize();
        }

        function setCurrentValue() {
            const variant = information.getCurrentVariant();

            updateCartButton(variant);
            updateAvailableFabricSelector(!!variant);
            updateProductPolicies(!!variant);

            if (!information.getCurrentVariant()) {
                return;
            }

            const currentSize = variant[propData.sizeThemeSelectorIndex];
            const currentFabric = variant[propData.fabricThemeSelectorIndex];
            const currentColor = variant[propData.colorThemeSelectorIndex];

            selected.size = currentSize;
            selected.fabric = currentFabric;
            selected.color = currentColor;

            const setCurrentSize = function () {
                const $sizeOptions = $selectors.contentSize.find('.item-size');

                $sizeOptions.each(function (index, item) {
                    if ($(item).data('value') === currentSize) {
                        const radioBtn = $(item).find('input');

                        radioBtn.attr('checked', true);

                        $selectors.sizeTrigger.find('.value').text(currentSize);
                    }
                });
            };

            const setActiveTab = function () {
                $selectors.navItems.each(function (index, item) {
                    if ($(item).data('fabric') === currentFabric) {
                        $(item).addClass('active-tab');
                        $(item).siblings().removeClass('active-tab');

                        const fabricName = utils.replaceSpace(currentFabric);
                        const element = $(`.${fabricName}`);

                        // show hide content of the tab
                        element.removeClass('hide');

                        element.siblings().addClass('hide');
                    }
                });
            };

            const setCurrentFabric = function () {
                const $fabrics = $selectors.contentFabric.find('.item-fabric');

                $fabrics.each(function (index, item) {
                    const that = $(item);

                    if (that.data('size') === currentSize) {
                        if (that.data('fabric') === currentFabric && that.data('color') === currentColor) {

                            that.addClass('active-fabric');

                            that.siblings().removeClass('active-fabric');

                            $selectors.fabricTrigger.find('.value').text(`${currentFabric} / ${currentColor}`);
                        }
                    } else {
                        that.addClass('disabled-fabric');
                    }

                });
            };

            const setCurrentImage = function () {
                updateVariant._updateImages(variant);
            };


            // updateAvailableTabs(currentSize);
            setCurrentSize();
            setActiveTab();
            setCurrentFabric();
            setCurrentImage();
            updateRangePriceByFabric();
        }

        function updateCartButton(variant) {

            const classes = {
                onSale: 'on-sale',
                disabled: 'disabled',
                isModal: 'is-modal',
                loading: 'loading',
                loaded: 'loaded',
                hidden: 'hide',
                interactable: 'video-interactable',
                visuallyHide: 'visually-invisible'
            };

            if (variant && !checkIfTagsExist()) {
                if (variant.available) {
                    // Available, enable the submit button and change text
                    $selectors.addToCart.removeClass(classes.disabled).prop('disabled', false);
                    const defaultText = $selectors.addToCartText.data('default-text');
                    $selectors.addToCartText.html(defaultText);
                } else {
                    // Sold out, disable the submit button and change text
                    $selectors.addToCart.addClass(classes.disabled).prop('disabled', true);
                    $selectors.addToCartText.html(theme.strings.soldOut);
                }
            } else {
                // The variant doesn't exist, disable submit button
                $selectors.addToCart.addClass(classes.disabled).prop('disabled', true);
                $selectors.addToCartText.html(theme.strings.unavailable);
            }
        }

        function updateProductPolicies(show) {
            if (show) {
                $selectors.productPolicies.removeClass('hide');
            } else {
                $selectors.productPolicies.addClass('hide');
            }
        }

        // disable/enable fabric selector
        function updateAvailableFabricSelector(available) {
            if (available) {
                $selectors.fabricTrigger.removeClass('unavailable');
            } else {
                $selectors.fabricTrigger.addClass('unavailable');
            }
        }

        // return selected variant
        function getSelectedVariant() {
            return _variants.find(function (variant) {
                const size = variant[propData.sizeThemeSelectorIndex];
                const fabric = variant[propData.fabricThemeSelectorIndex];
                const color = variant[propData.colorThemeSelectorIndex];

                if (selected.size === size && selected.fabric === fabric && selected.color === color) {
                  return variant;
                }
            });
        }

        // update view range-price block when select size
        function updateRangePriceBySize(size) {
            const variantsBySize = _variants
                .filter(variant => variant[propData.sizeThemeSelectorIndex] === size)
                .sort((a, b) => a.price - b.price);

            const fromPrice = theme.Currency.formatMoney(variantsBySize[0].price, theme.settings.moneyFormat);
            const toPrice = theme.Currency.formatMoney(variantsBySize[variantsBySize.length - 1].price, theme.settings.moneyFormat);

            const fromString = theme.strings.fromPrice.replace('{{ price }}', '');
            const toString = theme.strings.toPrice.replace('{{ price }}', '');

            $('#ProductRangePrice').html(`${fromString} ${fromPrice}<span> - </span>${toString} ${toPrice}`);

        }

        // update view range-price block when select fabric/material
        function updateRangePriceByFabric() {
            const selectedVariant = getSelectedVariant();

            const price = theme.Currency.formatMoney(selectedVariant.price, theme.settings.moneyFormat);

            $('#ProductRangePrice').html(price);
        }

        // return object with variants grouped by fabric
        function getGroupedVariantByFabric() {
            const groupedVariantByFabric = {};

            _fabrics.forEach((fabric) => {
                groupedVariantByFabric[fabric] = _variants.filter((variant) => variant[propData.fabricThemeSelectorIndex] === fabric)
            });

            return groupedVariantByFabric;

        }

        // disable a tab (Fabric) which don't have a variant in the selected size
        function updateAvailableTabs(size) {
            const groupedVariantByFabric = getGroupedVariantByFabric();
            const sizeAvailableOnFabric = {};

            Object.keys(groupedVariantByFabric).forEach(function (key, index){
                sizeAvailableOnFabric[key] = groupedVariantByFabric[key].some(function (variant) {
                    return variant[propData.sizeThemeSelectorIndex] === size;
                });
            });


            $selectors.navItems.each(function (index, item) {
                const fabric = $(item).data('fabric');

                if (!sizeAvailableOnFabric[fabric]) {
                    $(item).addClass('disabled');
                    $(item).removeClass('active-tab');
                } else {
                    $(item).removeClass('disabled')
                }
            });
        }

        // check in product has tags
        function checkIfTagsExist() {
            const tags = information.getTags();
            const byInShop = tags.includes('_label_Beställ i butik');
            const byInShopNew = tags.includes('_label_Nyhet i butik');

            return byInShop || byInShopNew;
        }


        onClickMenuTrigger();
        initSizeSelector();
        initFabricSelector();
        setCurrentValue();
    });

})(jQuery)

